export enum InterviewsConsts {
  GET_INTERVIEWS = 'GET:INTERVIEWS',
  GET_INTERVIEWS_OK = 'GET:INTERVIEWS_OK',
  GET_INTERVIEWS_KO = 'GET:INTERVIEWS_KO',

  GET_INTERVIEWS_FINISHED = 'GET:INTERVIEWS:FINISHED',
  GET_INTERVIEWS_FINISHED_OK = 'GET:INTERVIEWS:FINISHED:OK',
  GET_INTERVIEWS_FINISHED_KO = 'GET:INTERVIEWS:FINISHED:KO',
}
